// Copyright (c) 2021 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import PoolOrderExchangeDetail from './poolOrderExchangeDetail';
import React from 'react';

function PoolOrderExchangeDetailPage () {

    return (
        <AuthenticatedPage className="atp-page atp-pool-order-exchange-detail-page">
            <PoolOrderExchangeDetail />
        </AuthenticatedPage>
    );

}
PoolOrderExchangeDetailPage.displayNAme = 'PoolOrderExchangeDetailPage';

export default PoolOrderExchangeDetailPage;
